<mat-toolbar class="p-0 mat-elevation-z1">

	<div fxFlex fxFill fxLayout="row" fxLayoutAlign="start center">

		<div fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">

			<button mat-icon-button class="navbar-toggle-button"
					*ngIf="!hiddenNavbar && !rightNavbar" (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>
				<mat-icon class="secondary-text">menu</mat-icon>
			</button>

			<div class="toolbar-separator" *ngIf="!hiddenNavbar && !rightNavbar" fxHide.gt-md></div>

			<!-- <div fxLayout="row" fxLayoutAlign="start center" *ngIf="horizontalNavbar">
				<div class="logo ml-16">
					<img width="30" class="logo-icon" src="assets/images/logos/signus.svg">
				</div>
			</div> -->
			<!--<div class="px-8 px-md-16">
				<fuse-shortcuts [navigation]="navigation"></fuse-shortcuts>
			</div> -->

		</div>

		<div *ngIf="isAuthenticated=='true'" class="" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">

			<div *ngIf="logUltimoLogin != null" fxLayout="column" fxLayoutAlign="start start"  style="margin-bottom:20px;margin-right:20px;">
				<label class="ultimaSesionLabel"><strong>Su última visita fue: </strong>{{logUltimoLogin.fechaInicio | date : "yyyy-MM-dd hh:mm:ss"}}</label>
				<label class="ultimaSesionLabel"><strong>Desde:</strong> {{logUltimoLogin.ipConexion}}</label>
			</div>



			<button mat-button [matMenuTriggerFor]="vigenciaMenu" class="user-button" [ngClass]="{ 'green-900-fg' : vigenciaSistema?.estado == 'AC', 'blue-900-fg' : vigenciaSistema?.estado == 'PE', 'red-900-fg' : vigenciaSistema?.estado == 'IN'}">
				<div fxLayout="row" fxLayoutAlign="center center">
					<span fxHide fxShow.gt-sm><strong>{{vigenciaSistema?.id}}</strong></span>
					<mat-icon class="s-16" fxHide.xs>keyboard_arrow_down</mat-icon>
				</div>
			</button>

			<mat-menu #vigenciaMenu="matMenu" [overlapTrigger]="false">

				<button mat-menu-item *ngFor="let vigencia of vigencias" (click)="seleccionarVigencia(vigencia)" [ngClass]="{ 'green-900-fg' : vigencia.estado == 'AC', 'blue-900-fg' : vigencia.estado == 'PE', 'red-900-fg' : vigencia.estado == 'IN'}">
					<span><strong>{{vigencia.id}}</strong></span>
				</button>

			</mat-menu>



			<button mat-button [matMenuTriggerFor]="userMenu"
					class="user-button">
				<div fxLayout="row" fxLayoutAlign="center center">
					<img class="avatar mr-0 mr-sm-16" src="assets/images/avatars/profile.jpg">
					<span class="username mr-12" fxHide fxShow.gt-sm> {{nombreCompleto}}</span>
					<mat-icon class="s-16" fxHide.xs>keyboard_arrow_down</mat-icon>
				</div>
			</button>

			<mat-menu #userMenu="matMenu" [overlapTrigger]="false">

				<button mat-menu-item (click)="ActualizarDatos()">
					<mat-icon>account_box</mat-icon>
					<span>Actualizar Datos</span>
				</button>
				
				<button mat-menu-item (click)="CambiarPassword()">
					<mat-icon>vpn_key</mat-icon>
					<span>Cambiar Contraseña</span>
				</button>

				<button mat-menu-item (click)="IrAMiCuenta()">
					<mat-icon>manage_accounts</mat-icon>
					<span>Mi cuenta</span>
				</button>

				<button mat-menu-item *ngIf="EsAdministrador()" (click)="IrAIdenityAdmin()">
					<mat-icon>security</mat-icon>
					<span>Administrar usuarios</span>
				</button>

				<button mat-menu-item class="" (click)="signout()">
					<mat-icon>exit_to_app</mat-icon>
					<span>Cerrar Sesión</span>
				</button>

			</mat-menu>





			<!-- <div class="toolbar-separator"></div>

			<fuse-search-bar (input)="search($event)"></fuse-search-bar>

			<div class="toolbar-separator"></div>

			<button mat-button fxHide fxShow.gt-xs
					class="language-button"
					[matMenuTriggerFor]="languageMenu">
				<div fxLayout="row" fxLayoutAlign="center center">
					<img class="flag mr-8" [src]="'assets/icons/flags/'+selectedLanguage.flag+'.png'">
					<span class="iso text-uppercase">{{selectedLanguage.id}}</span>
				</div>
			</button>

			<mat-menu #languageMenu="matMenu" [overlapTrigger]="false">

				<button mat-menu-item *ngFor="let lang of languages" (click)="setLanguage(lang)">
					<span fxLayout="row" fxLayoutAlign="start center">
						<img class="flag mr-16" [src]="'assets/icons/flags/'+lang.flag+'.png'">
						<span class="iso">{{lang.title}}</span>
					</span>
				</button>

			</mat-menu>

			<div class="toolbar-separator" fxHide fxShow.gt-xs></div>

			<button mat-icon-button
					class="quick-panel-toggle-button"
					(click)="toggleSidebarOpen('quickPanel')"
					aria-label="Toggle quick panel">
				<mat-icon class="secondary-text">format_list_bulleted</mat-icon>
			</button>

			<div class="toolbar-separator" *ngIf="!hiddenNavbar && rightNavbar" fxHide fxShow.gt-xs></div>

			<button mat-icon-button class="navbar-toggle-button"
					*ngIf="!hiddenNavbar && rightNavbar" (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>
				<mat-icon class="secondary-text">menu</mat-icon>
			</button> -->

		</div>

	</div>

</mat-toolbar>
